import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, catchError, finalize, map, Observable, tap, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { CountersService } from "../counters/counters.service";

interface Workspace {
  id: number;
  name: string;
  owner: number; // Ensure this matches your backend response
  created: string;
  is_activated?: boolean; // Optional, based on your data
  status?: string;        // Optional, based on your data
  GitLab_id: number;
  active: number;
  public: string;
  resources_id: number;
}


@Injectable({
  providedIn: "root",
})
export class WorkspacesService {
  private apiWorkspacesUri = `${environment.apiUri}/workspaces`;

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();

  constructor(private http: HttpClient, private countersService: CountersService) {}

  startLoading(): void {
    this.isLoadingSubject.next(true);
  }

  stopLoading(): void {
    this.isLoadingSubject.next(false);
  }

  getWorkspaces(): Observable<{ data: Workspace[] }> {
    const url = `${this.apiWorkspacesUri}`;
    return this.http
      .get<{ data: Workspace[] }>(url, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  createWorkspace(newWorkspace: {
    user_id: number;
    resources_id: number;
    name: string;
  }): Observable<any> {
    return this.http
      .post<any>(`${this.apiWorkspacesUri}`, newWorkspace, {
        withCredentials: true,
      })
      .pipe(
        tap(() => {
          // Refresh counts after creating a workspace
          const userId = newWorkspace.user_id.toString();
          this.countersService.getCounts(userId, true).subscribe();
        }),
        catchError(this.handleError)
      );
  }

  updateWorkspace(workspaceId: number, updatedWorkspace: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiWorkspacesUri}/${workspaceId}`,
      updatedWorkspace,
      { withCredentials: true }
    );
  }

  private handleError(error: any) {
    console.error("An error occurred:", error);
    return throwError("Something bad happened; please try again later.");
  }
}
